// Local type definitions for DynamicChart
// These mirror the internal library types that aren't publicly exported

export type dataset = {
    labelName: string;
    values: number[];
    borderColor?: string[] | string;
    backgroundColor?: string[] | string;
    type?: datasetsEnums;
    hidden?: boolean;
};

export enum datasetsEnums {
    DELTA = "delta",
    ACCUMULATE = "accumulate",
    Actual = "actual",
}

export type formatFunction = (val: any, index?: number, ticks?: any) => string | number;

// Renamed to match library internal naming (defaultFormatters)
export enum chartAxisFormatEnums {
    NUMBER = "number",
    PERCENT = "percent",
    USD = "usd",
    DAILYDATE = "dailydate",
    HOURLYDATE = "hourlydate",
}

// Alias to match internal library type name
export { chartAxisFormatEnums as defaultFormatters };
